import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { first } from 'rxjs';
import { PWAService } from './common/services/pwa.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  providers: [PWAService],
})
export class App {
  constructor(private pwaService: PWAService) {
    // Warm the lazy toast chunk once the first page is in place (after its own chunks, not
    // competing with them): a tab that outlives a deploy without the service worker could no
    // longer download it later.
    inject(Router)
      .events.pipe(
        first((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(
        () => void import('./common/services/toast-container').catch(() => {}),
      );
  }
}
